/* Brands Swiper */
(() => {
  function init(el) {
    if (!el || !window.Swiper) return;
    
    const cfg = JSON.parse(el.dataset.config || '{}');
    const container = el.closest('.brands__carousel');
    const prevBtn = container?.querySelector('.brands__nav--prev');
    const nextBtn = container?.querySelector('.brands__nav--next');
    
    const options = {
      slidesPerView: cfg.colsMobile || 3,
      spaceBetween: cfg.gap || 16,
      loop: false,
      speed: 300,
      effect: 'slide',
      autoplay: cfg.auto && cfg.auto !== '0' ? { delay: parseInt(cfg.auto), disableOnInteraction: false } : false,
      breakpoints: { 750: { slidesPerView: cfg.cols || 6 } }
    };
    
    if (prevBtn && nextBtn) {
      options.navigation = { prevEl: prevBtn, nextEl: nextBtn };
    }
    
    new Swiper(el, options);
  }
  
  const run = () => document.querySelectorAll('.brands__swiper[data-config]').forEach(init);
  
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  
  document.addEventListener('shopify:section:load', e => {
    const el = e.target.querySelector('.brands__swiper[data-config]');
    if (el) init(el);
  });
})();
